import { useSelector } from "react-redux";

import messages from "../../../../../../../assets/locale/messages";
import {
  EmailSmallIcon,
  IdSmallIcon,
  PhoneSmallIcon,
  ProfileSmallIcon
} from "../../../../../../../utils/Icons";
import ViewUploadedFile from "../../../../../../../components/Upload/FileUpload/ViewUploadedFile";
import { OFF_PLATFORM_VERIFICATION_DOCUMENTS_TYPES } from "../../../../../../../utils/Constants";

const RepresentativeSection = () => {
  const lang = useSelector((state) => state.locale.lang);
  const {
    businessVerification: {
      requestDetails: {
        offplatformRequest: { reviewDocs }
      }
    }
  } = messages[lang];

  const requestDetails = useSelector(
    (state) =>
      state.businessVerification.offPlatformVerificationRequestDetails
  );

  const renderRepresentativeInfo = (icon, label, value) => (
    <div className="col-12 col-md-6 mb-4">
      <div className="d-flex align-items-center">
        <div className="me-4">{icon}</div>
        <div>
          <p className="mb-1 text-light-grey fsize-13">{label}</p>
          <p className="mb-0 text-color fsize-15 fweight-600 word-break">
            {value || "__"}
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="representative-info-section">
      <h6 className="fsize-16 fweight-600 title-color mb-4">
        {reviewDocs.representativeInfo}
      </h6>
      <div className="row mb-3">
        {renderRepresentativeInfo(
          <ProfileSmallIcon />,
          reviewDocs.representativeName,
          requestDetails?.CompanyDataDTO?.RepresentativeName
        )}
        {renderRepresentativeInfo(
          <EmailSmallIcon />,
          reviewDocs.representativeEmail,
          requestDetails?.CompanyDataDTO?.Email
        )}
        {renderRepresentativeInfo(
          <PhoneSmallIcon />,
          reviewDocs.representativeMobile,
          requestDetails?.CompanyDataDTO?.MobileNumber
        )}
        {renderRepresentativeInfo(
          <IdSmallIcon />,
          reviewDocs.representativeJobTitle,
          requestDetails?.CompanyDataDTO?.JobTitle
        )}
      </div>
      <p className="fsize-13 title-color">
        {reviewDocs.representativeId}
      </p>
      <div className="row">
        <div className="col-12 col-xl-6">
          <ViewUploadedFile
            file={requestDetails?.CompanyDataDTO?.RepresentativeIDDoc}
            type={
              requestDetails?.CompanyDataDTO?.OriginalRepresentativeIDDoc.includes(
                "pdf"
              )
                ? "pdf"
                : "image"
            }
            name={
              requestDetails?.CompanyDataDTO
                ?.OriginalRepresentativeIDDoc
            }
            viewMode
            isFileLink
          />
        </div>
      </div>
    </div>
  );
};

export default RepresentativeSection;
